import { z } from 'zod';
import { LocationIntegrationVendorTypeSchema } from './schemas.js';
import { BaseResponseSchema } from './schemas.js';
export const LocationTagPositionSourceSchema = z.enum(['uwb', 'vendor']);
/** Durable registry row for a runtime tag identity at a site (vendor poll or Cnapse UWB). */
export const LocationTagRegistryRecordSchema = z.object({
    tenantId: z.string().min(1).max(128),
    siteId: z.string().min(1).max(128),
    /** Runtime telemetry id (uppercase vendor tracking id or Cnapse serial). */
    tagId: z.string().min(1).max(128),
    positionSource: LocationTagPositionSourceSchema,
    vendorType: LocationIntegrationVendorTypeSchema.nullable().optional(),
    geofencingEnabled: z.boolean(),
    /** Set when this tag is also a claimed Cnapse node in device inventory. */
    linkedInventorySerial: z.string().nullable().optional(),
    firstSeenAt: z.string(),
    lastSeenAt: z.string(),
    updatedAt: z.string(),
    updatedBy: z.string().nullable().optional(),
});
export const LocationTagGeofencingPatchBodySchema = z.object({
    geofencingEnabled: z.boolean(),
});
export const LocationTagGeofencingParamsSchema = z.object({
    siteId: z.string().min(1).max(128),
    tagId: z.string().min(1).max(128),
});
export const LocationTagGeofencingByTagParamsSchema = z.object({
    tagId: z.string().min(1).max(128),
});
export const LocationTagGeofencingResponseSchema = BaseResponseSchema.extend({
    data: z.object({
        tenantId: z.string(),
        siteId: z.string(),
        tagId: z.string(),
        geofencingEnabled: z.boolean(),
        /** Site-level zone enter/exit alarms (cloudZoneAlarmsEnabled). False when site unknown. */
        zoneAlarmsEnabled: z.boolean(),
    }),
});
//# sourceMappingURL=location-tag-registry.schema.js.map